import React from 'react'
import "./Story.css"
const Story = () => {
  return (
   <div id="story-ol">
    <center>
        <h1>
            Our Story
        </h1>
        <div className="st-info">
            <p>
                Shrayati.com was founded with a mission to make a positive environmental impact.
            </p>
            <p>

Recognizing the need for sustainable alternatives in everyday products, we started with eco-friendly tissue papers and paper cups.
            </p>
            <p>

Driven by a passion for sustainability and innovation, we have expanded our product range to include a variety of high-quality, biodegradable products.
            </p>
            <p>

Our growth is a testament to our commitment to providing eco-friendly solutions that meet the needs of our customers.
            </p>
            <p>

We are dedicated to making it easier for everyone to make environmentally conscious choices in their daily lives.
            </p>
            <p>

Our journey continues as we strive to lead the market in sustainability and environmental responsibility, fostering a greener future for generations to come.
            </p>
        </div>
    </center>
   </div>
  )
}

export default Story
